import { has, isPlainObject, pickBy } from 'lodash';
import { CustomUnitsDefinition, HandlingUnits } from '@bringg/types';

export const excludeTrucksForHere = (dmEngine: string) => (category: string) =>
	dmEngine === 'here' ? category !== 'truck' : true;

export const toSubmittedHandlingUnits = (
	handlingUnits: unknown,
	customUnitsDefinition?: CustomUnitsDefinition
): HandlingUnits => {
	if (!isPlainObject(handlingUnits)) {
		return {};
	}

	const units = handlingUnits as HandlingUnits;

	// Configuration not loaded - the defined units are unknown, so send the stored map unchanged
	if (!customUnitsDefinition) {
		return units;
	}

	// Keep defined units with a positive value only: 0, negative or empty means the vehicle cannot carry the unit
	return pickBy(units, (value, unitKey) => value > 0 && has(customUnitsDefinition, unitKey));
};
